const colors = {
  "red": "#EF564A",
  "pink": "#fcbec3",
  "orange": '#f5af76',
  "green": "#5acc7d",
  "gray": '#bababa',
  "blue": '#1755c5'
}

const raceCandidateColors = {
  'us-senate-class-2-Republican': [
    {
      name: 'Ken Paxton',
      color: colors.pink
    },
    {
      name: 'Wesley Hunt',
      color: colors.orange
    },
    {
      name: 'John Cornyn',
      color: colors.red
    },
    {
      name: 'Virgil Bierschwale',
      color: colors.gray
    },
    {
      name: 'Anna Bender',
      color: colors.gray
    },
    {
      name: 'Gulrez "Gus" Khan',
      color: colors.gray
    },
    {
      name: 'Sara Canady',
      color: colors.gray
    },
    {
      name: 'John O. Adefope',
      color: colors.gray
    },
    {
      name: 'Uncommitted',
      color: colors.gray
    },
  ],
  'us-senate-class-2-Democrat': [
    {
      name: 'Jasmine Crockett',
      color: colors.blue
    },
    {
      name: 'James Talarico',
      color: colors.green
    },
    {
      name: 'Ahmad R. Hassan',
      color: colors.pink
    },
  ],
  'attorney-general-Republican': [
    {
      name: 'Aaron Reitz',
      color: colors.orange
    },
    {
      name: 'Chip Roy',
      color: colors.red
    },
    {
      name: 'Mayes Middleton',
      color: colors.pink
    },
    {
      name: 'Joan Huffman',
      color: colors.green
    },
  ],
  'comptroller-Republican': [
    {
      name: 'Kelly Hancock',
      color: colors.red
    },
    {
      name: 'Michael Berlanga',
      color: colors.gray
    },
    {
      name: 'Christi Craddick',
      color: colors.orange
    },
    {
      name: 'Don Huffines',
      color: colors.pink
    },
  ],
};

export default raceCandidateColors;
